export function stripDirection(
  folderName: string
): { baseName: string; direction: 'CW' | 'CCW' | null } {
  if (folderName.endsWith('_CCW') || folderName.endsWith(' CCW')) {
    return { baseName: folderName.slice(0, -4), direction: 'CCW' }
  }
  if (folderName.endsWith('_CW') || folderName.endsWith(' CW')) {
    return { baseName: folderName.slice(0, -3), direction: 'CW' }
  }
  return { baseName: folderName, direction: null }
}

/**
 * Detect CW/CCW from a file's webkitRelativePath parent folder segment.
 */
export function directionFromRelativePath(relativePath: string): 'CW' | 'CCW' | null {
  const parts = relativePath.replace(/\\/g, '/').split('/')
  if (parts.length < 2) return null
  const parent = parts[parts.length - 2]
  const { direction } = stripDirection(parent)
  return direction
}
